var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0477 7.15234C13.3692 7.53397 13.0296 8.26981 12.4083 8.72378C12.0265 9.00284 11.6951 9.43727 11.3413 9.7714C11.064 10.0333 10.7977 10.3247 10.5216 10.6008C9.6728 11.4496 8.85745 12.3426 8.00444 13.1956C7.94685 13.2532 7.25979 14.0284 7.29633 14.0686C7.65645 14.4647 8.10488 14.7536 8.37305 15.2229C8.70014 15.7953 9.2794 16.2416 9.59528 16.7943C9.7411 17.0495 10.0233 17.1815 10.2064 17.4103C10.4737 17.7444 10.8965 18.2234 11.254 18.4337C11.5322 18.5973 11.7362 18.8791 11.9718 19.0933C12.2695 19.3639 12.6629 19.6298 12.9127 19.9421C13.0669 20.1348 13.3516 20.3889 13.5627 20.5095C13.9078 20.7067 14.1166 21.1115 14.4842 21.2952",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5874 13.875C12.3731 13.875 17.1935 13.9623 21.9922 13.9623",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon-back.0b5050d8faf6910d276ca54f01457dc6.svg";
export { ForwardRef as ReactComponent };